import { useMemo } from "react";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useSelector } from "react-redux";
import DealerReviewFilter from "../../../Components/Filters/DealerReviewFilter";

const districtsDataApi = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-review/ms_vaahan_district_wise",
      body
    );
    return res.data || [];
  } catch (error) {
    console.error("Error fetching district data:", error);
    throw error;
  }
};

const MsVahanDistrict = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: districtData = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["msVahanDistrictsData", submitted],
    queryFn: () => districtsDataApi(data),
    staleTime: 0,
    cacheTime: 0,
  });

  const columns = useMemo(() => {
    if (districtData.length === 0) return [];

    const baseColumns = [
      {
        accessorKey: "DISTRICT",
        header: "District",
      },
    ];

    const sample = districtData[0];
    const groupedColumns = [];

    Object.entries(sample).forEach(([key, value]) => {
      if (key === "DISTRICT") return;

      if (typeof value === "object" && value !== null) {
        const nestedCols = Object.keys(value).map((innerKey) => ({
          accessorKey: `${key}.${innerKey}`,
          header: innerKey,
          Cell: ({ cell }) => {
            const val = cell.getValue();
            if (typeof val === "number") {
              return `${val}%`;
            }
            return val ?? "-";
          },
        }));

        groupedColumns.push({
          header: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase()),
          columns: nestedCols,
        });
      }
    });

    return [...baseColumns, ...groupedColumns];
  }, [districtData]);

  const table = useMaterialReactTable({
    columns,
    data: districtData,
    initialState: { density: "compact" },
    enablePagination: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    muiTableContainerProps: {
      sx: {
        maxHeight: "60vh",
        zIndex: 10,
      },
    },
    muiTableHeadCellProps: {
      sx: {
        color: "white",
        fontSize: "12px",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        fontSize: "12px",
      },
    },
    muiTableFooterCellProps: {
      sx: {
        fontSize: "11px",
      },
    },
  });

  return (
    <>
      <div className="">
        <DealerReviewFilter />
      </div>
      <div className="border border-gray-300 rounded-md max-h-[80vh] overflow-hidden text-sm mt-1">
        <MaterialReactTable table={table} />
      </div>
    </>
  );
};

export default MsVahanDistrict;
